"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function textCharsLength(value) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!value) {
    return new classes_1.ValidationResult(true);
  }
  if (typeof value !== 'string') {
    return new classes_1.ValidationResult(false, 'Tipo de dado inválido');
  }
  var minValue = properties.minValue,
    maxValue = properties.maxValue,
    exact = properties.exact;
  var valueCharLength = value.split('').length;
  if (!!minValue && valueCharLength < minValue) {
    return new classes_1.ValidationResult(false, "Valor \xE9 menor que o n\xFAmero minimo de caracteres ".concat(minValue));
  }
  if (!!maxValue && valueCharLength > maxValue) {
    return new classes_1.ValidationResult(false, "Valor \xE9 maior que o n\xFAmero de caracteres permitidos ".concat(maxValue));
  }
  if (!!exact) {
    if (valueCharLength > exact) {
      return new classes_1.ValidationResult(false, "O valor excede o limite de ".concat(exact, " caracteres"));
    } else if (valueCharLength < exact) {
      return new classes_1.ValidationResult(false, "O valor deve conter ".concat(exact, " caracteres"));
    } else {
      return new classes_1.ValidationResult(true);
    }
  }
  return new classes_1.ValidationResult(true);
}
exports.default = new classes_1.Validator(textCharsLength, {
  minValue: 0,
  maxValue: 30
});